import React from "react";

const WBCMobileNavContext = React.createContext({});

export default WBCMobileNavContext;
